import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, CheckCircle2, X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  minutesAgo: number;
  product: 'Hogar Natural' | 'Super Pack';
}
const PURCHASES: Purchase[] = [{
  name: 'Juan',
  city: 'Rosario',
  minutesAgo: 15,
  product: 'Super Pack'
}, {
  name: 'Laura',
  city: 'Córdoba',
  minutesAgo: 3,
  product: 'Hogar Natural'
}, {
  name: 'María',
  city: 'Mendoza',
  minutesAgo: 8,
  product: 'Super Pack'
}, {
  name: 'Diego',
  city: 'La Plata',
  minutesAgo: 22,
  product: 'Hogar Natural'
}, {
  name: 'Sofía',
  city: 'Tucumán',
  minutesAgo: 5,
  product: 'Super Pack'
}, {
  name: 'Martín',
  city: 'Buenos Aires',
  minutesAgo: 11,
  product: 'Hogar Natural'
}, {
  name: 'Valeria',
  city: 'Mar del Plata',
  minutesAgo: 2,
  product: 'Super Pack'
}, {
  name: 'Carolina',
  city: 'Salta',
  minutesAgo: 18,
  product: 'Hogar Natural'
}, {
  name: 'Federico',
  city: 'Neuquén',
  minutesAgo: 7,
  product: 'Super Pack'
}, {
  name: 'Lucía',
  city: 'San Juan',
  minutesAgo: 14,
  product: 'Hogar Natural'
}, {
  name: 'Roberto',
  city: 'Bahía Blanca',
  minutesAgo: 26,
  product: 'Super Pack'
}, {
  name: 'Camila',
  city: 'Posadas',
  minutesAgo: 4,
  product: 'Hogar Natural'
}, {
  name: 'Andrés',
  city: 'Santa Fe',
  minutesAgo: 9,
  product: 'Super Pack'
}, {
  name: 'Mónica',
  city: 'Resistencia',
  minutesAgo: 13,
  product: 'Hogar Natural'
}, {
  name: 'Pablo',
  city: 'San Luis',
  minutesAgo: 6,
  product: 'Super Pack'
}, {
  name: 'Florencia',
  city: 'Paraná',
  minutesAgo: 19,
  product: 'Hogar Natural'
}, {
  name: 'Gabriel',
  city: 'Bariloche',
  minutesAgo: 12,
  product: 'Super Pack'
}, {
  name: 'Natalia',
  city: 'Jujuy',
  minutesAgo: 3,
  product: 'Hogar Natural'
}, {
  name: 'Jorge',
  city: 'Río Cuarto',
  minutesAgo: 21,
  product: 'Super Pack'
}, {
  name: 'Daniela',
  city: 'Catamarca',
  minutesAgo: 8,
  product: 'Hogar Natural'
}];
const VISIBLE_DURATION = 6000; // 6s visible
const INTERVAL = 90000; // 1.5 minutes between notifications
export function PurchaseNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    // Show first notification after 5 seconds
    const firstShow = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(firstShow);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    if (isVisible) {
      // Hide after VISIBLE_DURATION
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, VISIBLE_DURATION);
      return () => clearTimeout(hideTimer);
    } else {
      // Show next notification after INTERVAL
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
      }, INTERVAL);
      return () => clearTimeout(showTimer);
    }
  }, [isVisible, dismissed]);
  if (dismissed) return null;
  const purchase = PURCHASES[currentIndex];
  return <div className="fixed bottom-4 left-4 z-[60] max-w-[calc(100vw-2rem)] sm:max-w-sm pointer-events-none" aria-live="polite" aria-atomic="true" data-id="element-416">
      <AnimatePresence data-id="element-417">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        y: 10
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="pointer-events-auto bg-white rounded-2xl shadow-[0_20px_50px_-10px_rgba(45,90,61,0.25),0_0_0_1px_rgba(212,162,76,0.2)] border border-sage-mist overflow-hidden" data-id="element-418">
            <div className="flex items-stretch" data-id="element-419">
              {/* Left accent bar */}
              <div className="w-1.5 bg-gradient-to-b from-honey-light via-honey to-honey-dark shrink-0" data-id="element-420" />

              <div className="flex items-start gap-3 p-3 pr-8 sm:p-4 sm:pr-10 relative" data-id="element-421">
                {/* Avatar with initial */}
                <div className="relative shrink-0" data-id="element-422">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-forest to-forest-deep text-honey-light flex items-center justify-center font-serif font-bold text-lg border-2 border-honey/40 shadow-sm" data-id="element-423">
                    {purchase.name.charAt(0)}
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-honey flex items-center justify-center border-2 border-white shadow" data-id="element-424">
                    <CheckCircle2 className="w-3 h-3 text-forest-deep" strokeWidth={3} data-id="element-425" />
                  </div>
                </div>

                {/* Text content */}
                <div className="min-w-0 flex-1" data-id="element-426">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-427">
                    <ShoppingBag className="w-3 h-3 text-honey-dark shrink-0" data-id="element-428" />
                    <span className="text-[10px] font-bold uppercase tracking-widest text-honey-dark" data-id="element-429">
                      Nueva compra
                    </span>
                  </div>
                  <p className="text-sm text-forest-deep leading-snug" data-id="element-430">
                    <span className="font-bold" data-id="element-431">{purchase.name}</span> de{' '}
                    <span className="font-bold" data-id="element-432">{purchase.city}</span>
                  </p>
                  <p className="text-xs text-forest/70 leading-snug mt-0.5" data-id="element-433">
                    Compró el{' '}
                    <span className="font-semibold text-forest" data-id="element-434">
                      {purchase.product}
                    </span>{' '}
                    · hace {purchase.minutesAgo} min
                  </p>
                </div>

                {/* Close button */}
                <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-forest/40 hover:text-forest-deep transition-colors p-1 rounded-full hover:bg-sage-mist/40" data-id="element-435">
                  <X className="w-3.5 h-3.5" data-id="element-436" />
                </button>
              </div>
            </div>

            {/* Progress bar */}
            <motion.div key={`bar-${currentIndex}`} initial={{
          scaleX: 1
        }} animate={{
          scaleX: 0
        }} transition={{
          duration: VISIBLE_DURATION / 1000,
          ease: 'linear'
        }} style={{
          transformOrigin: 'left'
        }} className="h-0.5 bg-honey/60" data-id="element-437" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}